<template>
    <div class="slide">
        <TriviaCard :currentTrivia="currentTrivia" :title="questions.question.title"
                    :answers="questions.question.answers"
                    :correctAnswer="questions.question.correctAnswer"
                    :nextRoute="nextRoute"
                    :current="1"
                    :total="4" />
    </div>
</template>

<script>
import TriviaCard from '@/components/TriviaCard.vue'

export default {
    name: 'trivia',
    components: {
        TriviaCard,
    },
    data() {
        return {
            nextRoute: "trivia-12",
            currentTrivia: 11,
            questions: {
                question: {
                    "title": "Cruella DeWalt has been apprehended and is in custody. When should you contact your investigator?",
                    "answers": [
                        {"key": "A", "answer": "Immediately, unless it’s late at night"},
                        {"key": "B", "answer": "After you call law enforcement"},
                        {"key": "C", "answer": "After she is booked in jail"},
                        {"key": "D", "answer": "Immediately"}
                    ],
                    "correctAnswer": ["D"]
                }
            }
        }
    },
  mounted() {
    window.setTimeout(() => {
          window.scrollTo(0,1)
        }, 1000)
  }
}
</script>

<style lang="scss" scoped>

</style>
